<template>
  <div class="count-control" :style="{ maxWidth: size * 4.31 + 'px' }">
    <div
      class="count-plus"
      :style="{
        width: size + 'px',
        height: size + 'px',
        backgroundSize: size / 2 + 'px',
      }"
      @click="$emit('plus')"
    ></div>
    <div class="count" :style="{ fontSize: 0.65 * size + 'px' }">
      {{ value }}
    </div>
    <div
      class="count-minus"
      :style="{
        width: size + 'px',
        height: size + 'px',
        backgroundSize: size / 2 + 'px',
        minWidth: 0.9 * size + 'px',
      }"
      @click="$emit('minus')"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
    },
    size: {
      type: Number,
      default: 44,
    },
  },
};
</script>

<style lang="scss" scoped>
.count-control {
  display: flex;
  flex-basis: 50%;
  justify-content: space-between;

  .count-minus,
  .count-plus {
    border: solid 1.1px #686868;
    background-color: #ffffff;
    border-radius: 50%;
    background-position: center;
    background-repeat: no-repeat;
    cursor: pointer;
  }

  .count-minus {
    background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='4' viewBox='0 0 21 4'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0H31.36V31.36H0z' transform='translate(-4.728 -13.728)'/%3E%3Cpath stroke='%23000' stroke-width='2.509' d='M5.645 15.68L25.715 15.68' transform='translate(-4.728 -13.728)'/%3E%3C/g%3E%3C/svg%3E%0A");
  }

  .count-plus {
    background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='21' height='21' viewBox='0 0 21 21'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath d='M0 0H31.36V31.36H0z' transform='translate(-4.728 -4.728)'/%3E%3Cpath stroke='%23000' stroke-width='2.509' d='M5.645 15.68L25.715 15.68M15.68 5.645L15.68 25.715' transform='translate(-4.728 -4.728)'/%3E%3C/g%3E%3C/svg%3E%0A");
  }

  .count {
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: right;
    color: #202020;
    text-align: center;
  }
}
</style>